import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// const CustomClientDashboard = lazy(() => import("./CustomClientDashboard"));

const CustomClientDashboardNew = lazy(() => import("./CustomClientDashboardNew"));

const CUSTDASH_ROUTES: RouteObject[] = [
  {
    path: "/private/clients",
    element: React.createElement(CustomClientDashboardNew),
  },
];

export default CUSTDASH_ROUTES;
